/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var S = v, g = h, l = Object.prototype.toString, c = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function v(e, f) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var a = {}, i = f || {}, p = i.decode || w, t = 0; t < e.length; ) {
    var r = e.indexOf("=", t);
    if (r === -1)
      break;
    var o = e.indexOf(";", t);
    if (o === -1)
      o = e.length;
    else if (o < r) {
      t = e.lastIndexOf(";", r - 1) + 1;
      continue;
    }
    var n = e.slice(t, r).trim();
    if (a[n] === void 0) {
      var s = e.slice(r + 1, o).trim();
      s.charCodeAt(0) === 34 && (s = s.slice(1, -1)), a[n] = y(s, p);
    }
    t = o + 1;
  }
  return a;
}
function h(e, f, a) {
  var i = a || {}, p = i.encode || d;
  if (typeof p != "function")
    throw new TypeError("option encode is invalid");
  if (!c.test(e))
    throw new TypeError("argument name is invalid");
  var t = p(f);
  if (t && !c.test(t))
    throw new TypeError("argument val is invalid");
  var r = e + "=" + t;
  if (i.maxAge != null) {
    var o = i.maxAge - 0;
    if (isNaN(o) || !isFinite(o))
      throw new TypeError("option maxAge is invalid");
    r += "; Max-Age=" + Math.floor(o);
  }
  if (i.domain) {
    if (!c.test(i.domain))
      throw new TypeError("option domain is invalid");
    r += "; Domain=" + i.domain;
  }
  if (i.path) {
    if (!c.test(i.path))
      throw new TypeError("option path is invalid");
    r += "; Path=" + i.path;
  }
  if (i.expires) {
    var n = i.expires;
    if (!m(n) || isNaN(n.valueOf()))
      throw new TypeError("option expires is invalid");
    r += "; Expires=" + n.toUTCString();
  }
  if (i.httpOnly && (r += "; HttpOnly"), i.secure && (r += "; Secure"), i.priority) {
    var s = typeof i.priority == "string" ? i.priority.toLowerCase() : i.priority;
    switch (s) {
      case "low":
        r += "; Priority=Low";
        break;
      case "medium":
        r += "; Priority=Medium";
        break;
      case "high":
        r += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (i.sameSite) {
    var u = typeof i.sameSite == "string" ? i.sameSite.toLowerCase() : i.sameSite;
    switch (u) {
      case !0:
        r += "; SameSite=Strict";
        break;
      case "lax":
        r += "; SameSite=Lax";
        break;
      case "strict":
        r += "; SameSite=Strict";
        break;
      case "none":
        r += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return r;
}
function w(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function d(e) {
  return encodeURIComponent(e);
}
function m(e) {
  return l.call(e) === "[object Date]" || e instanceof Date;
}
function y(e, f) {
  try {
    return f(e);
  } catch {
    return e;
  }
}
export {
  S as parse,
  g as serialize
};
